module.exports = __webpack_public_path__ + "static/media/92.70c84bd9.jpg";